import React from "react";
import bgVideo from "../../assets/earth-bg.mp4";
import Navbar from "../Navbar/Navbar";
import Hero from "../Hero/Hero";
import Services from "../Services/Services";
import Banner from "../Banner/Banner";
import Banner2 from "../Banner/Banner2";
import Testimonials from "../Testimonials/Testimonials";
import AppStore from "../AppStore/AppStore";
import Footer from "../Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  React.useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 700,
      easing: "ease-in-out",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <div>
      <div className="h-[700px] relative">
        <video
          autoPlay
          loop
          muted
          className="fixed right-0 top-0 h-[700px] w-full object-cover z[-1]"
        >
          <source src={bgVideo} type="video/mp4" />
        </video>
        <Navbar />
        <Hero />
      </div>

      {/* Services Card Section */}
      <Services />
      <Banner />
      <Banner2 />
      <Testimonials />
      <AppStore />
      <Footer />
    </div>
  );
};

export default Home;
